<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
   <div class="save-panel">
          <button class="btn  btn-warning btn-icon" @click="updateItem">
               <span class="ti-save"></span>{{'save' | setText('Сохранить')}}
          </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "business/notifications",
    cardSetLink: "business/notifications",
    item: null,
    fields: [
             {
                    col:'col-12 col-md-6',
                    key: "title",
                    label: "Заголовок",
                    type: "field",
                    textType: "text",
              },
             {
                 
                    key: "description",
                    label: "Описание",
                    type: "textarea",
                    textType: "text",
              },
      ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
